module.exports = __webpack_public_path__ + "img/FIA_plavi_znak.a2e41973.png";